import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import './index.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginPage from './pages/LoginPage'
import useGlobale from './components/global'
import AuthProvider from './components/AuthProvider'
import Dashboard from './pages/DashboardPage'
import UtilisateursPage from './pages/UtilisateursPage'
import GroupePage from './pages/GroupePage'
import PublicationPage from './pages/PublicationPage'
import SignalementPage from './pages/SignalementPage'
import FormationPage from './pages/FormationPage'
import EvenementPage from './pages/EvenementPage'
import ProduitServicePage from './pages/ProduiServicePage'
import NotificationPage from './pages/NotificationPage'

// Composant pour protéger les routes
const PrivateRoute = ({ element: Component }) => {
  const { authenticated_fonap } = useGlobale();

  if (!authenticated_fonap) {
    return <Navigate to="/connexion" replace />;
  }

  return Component;
};

// Composant principal qui wrappe l'application
const AppRouter = () => {
  return (
    <AuthProvider>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={7000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/connexion" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
          <Route path="/users" element={<PrivateRoute element={<UtilisateursPage />} />} />
          <Route path="/groups" element={<PrivateRoute element={<GroupePage />} />} />
          <Route path="/publications" element={<PrivateRoute element={<PublicationPage />} />} />
          <Route path="/reports" element={<PrivateRoute element={<SignalementPage />} />} />
          <Route path="/formations" element={<PrivateRoute element={<FormationPage />} />} />
          <Route path="/events" element={<PrivateRoute element={<EvenementPage />} />} />
          <Route path="/products" element={<PrivateRoute element={<ProduitServicePage />} />} />
          
          {/* Routes à venir */}
          <Route path="/friendship-requests" element={<PrivateRoute element={
            <div className="p-6"><h1 className="text-2xl font-bold">Demandes d'amitié</h1><p className="mt-4">Page en développement...</p></div>
          } />} />
          <Route path="/chat" element={<PrivateRoute element={
            <div className="p-6"><h1 className="text-2xl font-bold">Messagerie</h1><p className="mt-4">Page en développement...</p></div>
          } />} />
          <Route path="/analytics" element={<PrivateRoute element={
            <div className="p-6"><h1 className="text-2xl font-bold">Analytiques</h1><p className="mt-4">Page en développement...</p></div>
          } />} />
          <Route path="/notifications" element={<PrivateRoute element={<NotificationPage />} />} />
          <Route path="/settings" element={<PrivateRoute element={
            <div className="p-6"><h1 className="text-2xl font-bold">Paramètres</h1><p className="mt-4">Page en développement...</p></div>
          } />} />
          
          {/* Route 404 */}
          <Route path="*" element={<div className="p-6"><h1 className="text-2xl font-bold">Page non trouvée</h1></div>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

// Rendu sans StrictMode pour éviter les doubles rendus
ReactDOM.createRoot(document.getElementById('root')).render(
  <AppRouter />
);